export default __webpack_public_path__ + "static/img-baker-roham-gharegozlou-4edd316dcee72388f2324de2682f928b.png";